import { get, post, put, remove } from "./api_helper";
import * as url from "./url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getPayrollStagingDiff = async (id) =>
  await get(baseURL + url?.PAYROLLSTAGING_DIFFERENCE + `/${id}`);
export const MoveToPayroll = async (id) =>
  post(baseURL + url?.MOVE_TO_PAYROLL + `/${id}`);
